import { Checkbox } from "@mantine/core";
import { useMemo } from "react";
import {
  type Control,
  type FieldErrors,
  type UseFormRegister,
  type UseFormSetValue,
} from "react-hook-form";
import { useLocation } from "react-router-dom";
import DateRangeInput from "src/components/shared/_FormInputs/DateRangeInput";
import Select from "src/components/shared/_FormInputs/Select";
import { type IRevAudForm } from "src/pages/Summary/RevAudCreate/RevAudCreate.types";
import { SectionDivider } from "src/styled";

interface Props {
  setValue: UseFormSetValue<IRevAudForm>;
  errors: FieldErrors<IRevAudForm>;
  control: Control<IRevAudForm>;
  register: UseFormRegister<IRevAudForm>;
}

const RevAudDetailsForm = ({ setValue, errors, control, register }: Props) => {
  const { pathname } = useLocation();
  const isAuditsPage = useMemo(() => pathname.includes("audits"), [pathname]);

  return (
    <>
      <SectionDivider mb={30}>Details</SectionDivider>
      <DateRangeInput
        returnFormat="YYYY-MM-DD"
        names={["start", "end"]}
        setValue={setValue}
        w="70%"
        type="range"
        label="Access Period"
        placeholder="Pick dates range"
        error={!!errors.start || !!errors.end}
      />
      <DateRangeInput
        returnFormat="YYYY-MM-DD"
        names={["revstart", "revend"]}
        setValue={setValue}
        w="70%"
        type="range"
        label="Entries Between"
        placeholder="Pick dates range"
        error={!!errors.revstart || !!errors.revend}
      />
      <Select
        w="70%"
        control={control}
        name="type"
        label={`${isAuditsPage ? "Audit" : "Review"} Type`}
        data={
          isAuditsPage
            ? [{ label: "Audit", value: "1000" }]
            : [
                { label: "Management Review", value: "240" },
                { label: "Yacht Review", value: "250" },
              ]
        }
        error={!!errors.type}
      />
      <Checkbox
        style={{ width: "60%" }}
        label="Send Email"
        {...register("email")}
      />
      <Checkbox
        style={{ width: "60%" }}
        label="Separate reviews by logbook"
        {...register("separate")}
      />
    </>
  );
};

export default RevAudDetailsForm;
